export default __webpack_public_path__ + "static/media/search.ead56e55.svg";